import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
// 首页静态加载,其余路由全部懒加载(首屏只下载必要代码)
import homeMap from "../views/homeMap/homeMap.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/login.vue"),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/",
    name: "homeMap",
    component: homeMap,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/home",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/home.vue"),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/login_whatsapp",
    name: "login_whatsapp",
    component: () =>
      import(
        /* webpackChunkName: "loginWhatsapp" */ "../views/login/loginWhatsapp.vue"
      ),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/login_whatsapp_complete",
    name: "login_whatsapp_complete",
    component: () =>
      import(
        /* webpackChunkName: "loginWhatsappComplete" */ "../views/login/loginWhatsappComplete.vue"
      ),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/login_wechat",
    name: "login_wechat",
    component: () =>
      import(/* webpackChunkName: "loginWechat" */ "../views/login/wechat.vue"),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/login_alipay",
    name: "login_alipay",
    component: () =>
      import(/* webpackChunkName: "loginAlipay" */ "../views/login/alipay.vue"),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/about.vue"),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/confirm",
    name: "confirm",
    component: () =>
      import(/* webpackChunkName: "confirm" */ "../views/confirm/confirm.vue")
  },
  {
    path: "/wallet",
    name: "wallet",
    component: () =>
      import(/* webpackChunkName: "wallet" */ "../views/wallet/wallet.vue")
  },
  {
    path: "/result",
    name: "result",
    component: () =>
      import(/* webpackChunkName: "result" */ "../views/result/result.vue")
  },
  {
    path: "/order",
    name: "order",
    component: () =>
      import(/* webpackChunkName: "order" */ "../views/order/order.vue")
  },
  {
    path: "/order/:orderId",
    name: "orderDetail",
    component: () =>
      import(
        /* webpackChunkName: "orderDetail" */ "../views/order/orderDetail"
      ),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/setting",
    name: "setting",
    component: () =>
      import(/* webpackChunkName: "setting" */ "../views/setting/setting.vue"),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/shop",
    name: "shop",
    component: () =>
      import(/* webpackChunkName: "shop" */ "../views/shop/shop.vue")
  },
  {
    path: "/help",
    name: "help",
    component: () =>
      import(/* webpackChunkName: "help" */ "../views/help/help.vue"),
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: "/wallet_in",
    name: "wallet_in",
    component: () =>
      import(/* webpackChunkName: "walletIn" */ "../views/wallet/wallet_in.vue")
  },
  {
    path: "/wallet_out",
    name: "wallet_out",
    component: () =>
      import(
        /* webpackChunkName: "walletOut" */ "../views/wallet/wallet_out.vue"
      )
  },
  {
    path: "/wallet_list",
    name: "wallet_list",
    component: () =>
      import(
        /* webpackChunkName: "walletList" */ "../views/wallet/wallet_list.vue"
      )
  },
  {
    path: "/google_map",
    name: "google_map",
    component: () =>
      import(/* webpackChunkName: "googleMap" */ "../views/map/google-index.vue"),
    alias: "/map"
  },
  {
    path: "/nearby_shop",
    name: "nearby_shop",
    component: () =>
      import(/* webpackChunkName: "nearbyShop" */ "../views/nearby/shop")
  },
  {
    path: "/selectPakage",
    name: "selectPakage",
    component: () =>
      import(
        /* webpackChunkName: "selectPakage" */ "../views/selectPakage/selectPakage"
      )
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.VUE_APP_DOMAIN,
  routes
});

router.beforeEach((to, from, next) => {
  console.log("to", to);
  // 修复被HTML转义过的链接中的&(外链/消息里带进来的&amp;),否则query解析错乱页面参数全丢
  if (to.fullPath.indexOf("&amp;") > -1) {
    next(to.fullPath.replace(/&amp;/g, "&"));
    return;
  }
  const token = store.state.token;
  if (to.name === "home") {
    if (to.query.qrcode) {
      store.commit("qrcode", to.query.qrcode);
      store.commit("zhcode", "");
    }
    if (to.query.zhcode) {
      store.commit("zhcode", to.query.zhcode);
      store.commit("qrcode", "");
    }
  }
  if (to.matched.some(r => r.meta.ignoreAuth) || token) {
    next();
  } else {
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  }
});

export default router;
